export class SubheaderItemTitleMapper {
  constructor(private readonly mappingData?: Record<string, string>) {}

  public mapType(type: string): string {
    const { mappingData } = this;
    const value = mappingData?.[type] || mappingData?.[type.toLowerCase()];
    return value ?? type;
  }
}
